/**
 * Taryfy G11, G12 i G12w: domyślne ceny prądu na 2026 rok do rachunku pieniędzy (teczka instalacji,
 * Projekt 3D, oferta, karta klienta).
 *
 * ═══ TO JEST PLIK DO RĘCZNEJ EDYCJI, RAZ W ROKU ═══
 * Decyzja właściciela 2026-10-23: trzy taryfy, każda z jedną domyślną ceną, a klient może wpisać cenę
 * z rachunku; „nie wiem” liczymy jak G11. Domyślna cena to średnia czterech dużych: sprzedawców z urzędu
 * (PGE Obrót, Tauron Sprzedaż, Enea, Energa Obrót) i ich operatorów (PGE Dystrybucja, Tauron Dystrybucja,
 * Enea Operator, Energa Operator), bez ważenia liczbą odbiorców. Źródła z adresami i stronami dokumentów:
 * `VV/dane_badawcze/taryfy_2026/` (`sprzedaz_energii_2026.md`, `dystrybucja_2026.md`, `net_billing_2026.md`).
 * Na nowy rok: przepisz liczby z decyzji URE (grudzień) i sprawdź, czy w ciągu roku nie było zmian.
 *
 * ═══ DLACZEGO ENERGIA OSOBNO OD DYSTRYBUCJI ═══
 * Prąd z paneli zużyty u siebie oszczędza obie części. Depozyt prosumenta płaci tylko za część energii
 * (art. 4c ustawy o OZE), więc rachunek musi wiedzieć, ile z każdej kupionej kWh to energia.
 *
 * Liczymy tylko opłaty za kWh. Opłaty stałe (składnik stały sieciowej, opłata mocowa; abonament OSD
 * zniknął od 1.10.2026) zostają z panelami takie same, więc nie zmieniają oszczędności.
 */

export const STAN_TARYF = '2026-10-23'
export const ZRODLO_CEN_TARYF = 'średnia PGE, Tauron, Enea i Energa z taryf na 2026 r. zatwierdzonych przez URE'

export const VAT = 0.23

/** Akcyza na energię elektryczną: 5 zł/MWh, poza cenami netto z taryf sprzedawców. */
export const AKCYZA_ZL_KWH = 0.005

/**
 * Opłaty za kWh doliczane do dystrybucji, jednakowe w całym kraju (netto): jakościowa (0,0332 od 1.02.2026,
 * wcześniej 0,0331), OZE 7,30 zł/MWh, kogeneracyjna 3,00 zł/MWh. Opłata przejściowa w 2026 r. nie obowiązuje.
 */
export const OPLATY_ZA_KWH_NETTO = Object.freeze({ jakosciowa: 0.0332, oze: 0.0073, kogeneracyjna: 0.003 })

/** Ceny energii czynnej netto, zł/kWh, z taryf sprzedawców na 2026 r. (bez VAT i akcyzy). */
export const SPRZEDAZ_NETTO_2026 = Object.freeze({
  pge: { G11: [0.4982], G12: [0.5656, 0.3718], G12w: [0.5821, 0.4235] },
  tauron: { G11: [0.4970], G12: [0.5430, 0.4130], G12w: [0.6220, 0.4130] },
  enea: { G11: [0.4980], G12: [0.5779, 0.3369], G12w: [0.6518, 0.3465] },
  energa: { G11: [0.4968], G12: [0.5789, 0.3753], G12w: [0.6057, 0.3940] },
})

/** Składnik zmienny stawki sieciowej netto, zł/kWh, z taryf OSD na 2026 r. Strefy: [droższa, tańsza]. */
export const DYSTRYBUCJA_NETTO_2026 = Object.freeze({
  pge: { G11: [0.3469], G12: [0.4014, 0.0765], G12w: [0.4276, 0.0845] },
  tauron: { G11: [0.2464], G12: [0.2841, 0.0558], G12w: [0.3298, 0.0512] },
  enea: { G11: [0.2456], G12: [0.2779, 0.0913], G12w: [0.2702, 0.0813] },
  energa: { G11: [0.3485], G12: [0.3844, 0.0827], G12w: [0.4017, 0.0851] },
})

const srednia = (t) => t.reduce((a, b) => a + b, 0) / t.length
const sredniaFirm = (tabela, grupa, strefa) => srednia(Object.values(tabela).map((f) => f[grupa][strefa]))
const OPLATY_NETTO = Object.values(OPLATY_ZA_KWH_NETTO).reduce((a, b) => a + b, 0)
const zaokr4 = (v) => Math.round(v * 10000) / 10000

/** Strefa z ceną brutto: energia (z akcyzą) i dystrybucja (z opłatami za kWh), obie z VAT. */
const strefa = (grupa, i, key, label) => {
  const energiaZlKwh = zaokr4((sredniaFirm(SPRZEDAZ_NETTO_2026, grupa, i) + AKCYZA_ZL_KWH) * (1 + VAT))
  const dystrybucjaZlKwh = zaokr4((sredniaFirm(DYSTRYBUCJA_NETTO_2026, grupa, i) + OPLATY_NETTO) * (1 + VAT))
  return Object.freeze({ key, label, energiaZlKwh, dystrybucjaZlKwh, cenaZlKwh: zaokr4(energiaZlKwh + dystrybucjaZlKwh) })
}

/**
 * Godziny stref wg taryf OSD 2026 (wszystkie liczą je w czasie zimowym przez cały rok, więc latem
 * „13–15” to 14–16 na zegarku): Tauron i Energa tańsze 13–15 i 22–6; PGE zimą 13–15 i 22–6, latem
 * (IV–IX) 15–17 i 22–6; Enea w G12 dwie godziny z okna 13–17 i osiem z 22–7, które wybiera operator.
 * G12w: to samo w dni robocze (Enea w dni robocze tylko 21–6), a weekendy i święta całe tańsze.
 */
export const TARYFY = Object.freeze([
  Object.freeze({
    key: 'G11',
    label: 'G11',
    opis: 'jedna cena przez całą dobę',
    strefy: Object.freeze([strefa('G11', 0, 'calodobowa', 'cała doba')]),
    godziny: '',
    godzinyKrotko: '',
    uzasadnienieUdzialu: '',
  }),
  Object.freeze({
    key: 'G12',
    label: 'G12',
    opis: 'tańsze noce i dwie godziny po południu',
    strefy: Object.freeze([strefa('G12', 0, 'droga', 'godziny droższe'), strefa('G12', 1, 'tania', 'godziny tańsze')]),
    godziny: 'Tańsze godziny: 22–6 i zwykle 13–15 (u PGE latem 15–17), liczone w czasie zimowym.',
    godzinyKrotko: 'w dzień zwykle 13–15',
    uzasadnienieUdzialu: 'Udział wyliczyliśmy z godzinowej produkcji PVGIS dla środka Polski przy równym zużyciu w ciągu doby, średnio dla godzin stref czterech operatorów.',
  }),
  Object.freeze({
    key: 'G12w',
    label: 'G12w',
    opis: 'jak G12, a do tego tanie weekendy',
    strefy: Object.freeze([strefa('G12w', 0, 'droga', 'godziny droższe'), strefa('G12w', 1, 'tania', 'godziny tańsze')]),
    godziny: 'Tańsze: noce, całe weekendy i święta, a w dni robocze zwykle też 13–15 (Enea bez okna w południe).',
    godzinyKrotko: 'weekendy, święta i w dni robocze zwykle 13–15',
    uzasadnienieUdzialu: 'Udział wyliczyliśmy z godzinowej produkcji PVGIS dla środka Polski przy równym zużyciu w ciągu doby, średnio dla godzin stref czterech operatorów.',
  }),
])

export const TARYFA_DOMYSLNA = 'G11'
/** „Nie wiem” liczymy jak G11 (decyzja właściciela 2026-10-23). */
export const TARYFA_NIE_WIEM = 'nie_wiem'

export const taryfaPoKluczu = (key) => TARYFY.find((t) => t.key === key) || TARYFY[0]

/**
 * Jaka część prądu z paneli zużytego u siebie przypada na tańsze godziny, miesiącami (I–XII).
 * Wyliczenie VoltValue (`net_billing_2026.md`, sekcja 4): godzinowa produkcja PVGIS 2019–2023 dla
 * łódzkiego (moduły na południe, 35°), zużycie domu równe w godzinach doby, autokonsumpcja w godzinie to
 * mniejsza z produkcji i zużycia, strefy z taryf czterech OSD (dla Enei w G12 przyjęte 13–15 i 22–6),
 * średnia z czterech. Wynik prawie nie zależy od wielkości instalacji (0,8–1,2 kWp na 1 MWh zużycia).
 */
export const UDZIAL_PV_W_TANIEJ = Object.freeze({
  G11: Object.freeze(Array(12).fill(0)),
  G12: Object.freeze([0.263, 0.231, 0.197, 0.181, 0.184, 0.189, 0.181, 0.178, 0.188, 0.221, 0.257, 0.277]),
  G12w: Object.freeze([0.449, 0.426, 0.383, 0.409, 0.428, 0.421, 0.387, 0.398, 0.378, 0.416, 0.477, 0.43]),
})

/**
 * Część zużycia domu w tańszych godzinach, przy zużyciu równym w ciągu doby (to samo wyliczenie): do kosztu
 * prądu bez paneli i do części energii w kWh kupowanym z sieci. Domy w G12 często przesuwają zużycie na
 * tańsze godziny, więc to raczej dolna granica.
 */
export const UDZIAL_ZUZYCIA_W_TANIEJ = Object.freeze({ G11: 0, G12: 0.417, G12w: 0.59 })
